<div class="deletion-page">
  <div class="deletion-card">

    <ng-container *ngIf="!done; else successState">
      <h1>{{ 'user.accountDeletion.title' | transloco }}</h1>

      <p class="deletion-lead">{{ 'user.accountDeletion.intro' | transloco }}</p>

      <!-- Avisos obrigatórios (Apple/Google): sempre ANTES do botão. -->
      <h2 class="deletion-section">{{ 'user.accountDeletion.immediate.title' | transloco }}</h2>
      <ul class="deletion-warnings">
        <li>{{ 'user.accountDeletion.immediate.devices' | transloco }}</li>
        <li>{{ 'user.accountDeletion.immediate.plan' | transloco }}</li>
        <!-- Saldo só existe para tuner; sem saldo (ou sem conseguir ler) a linha some. -->
        <li *ngIf="cashbackAmount">{{ 'user.accountDeletion.immediate.cashback' | transloco: { amount: cashbackAmount } }}</li>
      </ul>

      <h2 class="deletion-section">{{ 'user.accountDeletion.after30Days.title' | transloco }}</h2>
      <ul class="deletion-warnings">
        <li>{{ 'user.accountDeletion.after30Days.files' | transloco }}</li>
        <li>{{ 'user.accountDeletion.after30Days.posts' | transloco }}</li>
        <li>
          {{ 'user.accountDeletion.after30Days.legalRetention' | transloco }}
          <a [href]="privacyPolicyUrl" target="_blank" rel="noopener">{{ 'user.accountDeletion.privacyPolicy' | transloco }}</a>.
        </li>
        <li>{{ 'user.accountDeletion.after30Days.localData' | transloco }}</li>
      </ul>

      <div class="deletion-notice">
        <p class="deletion-export-text">{{ 'user.accountDeletion.export.intro' | transloco }}</p>
        <app-data-export></app-data-export>
      </div>

      <div class="deletion-field">
        <label for="confirmationEmail">{{ 'user.accountDeletion.confirmEmailLabel' | transloco }}</label>
        <input
          id="confirmationEmail"
          name="confirmationEmail"
          type="email"
          pInputText
          autocomplete="off"
          [(ngModel)]="confirmationEmail"
          (ngModelChange)="emailMismatch = false"
          (keyup.enter)="submit()"
        />
        <small class="deletion-error" *ngIf="emailMismatch">{{ 'user.accountDeletion.emailMismatch' | transloco }}</small>
      </div>

      <div class="deletion-actions">
        <p-button
          severity="danger"
          [raised]="true"
          [loading]="submitting"
          [disabled]="!canSubmit"
          label="{{ 'user.accountDeletion.submit' | transloco }}"
          (onClick)="submit()">
        </p-button>
        <a class="deletion-back" (click)="goBack()">{{ 'user.accountDeletion.back' | transloco }}</a>
      </div>

      <p class="deletion-footer">
        {{ 'user.accountDeletion.footer' | transloco }}
        <a [href]="privacyPolicyUrl" target="_blank" rel="noopener">{{ 'user.accountDeletion.privacyPolicy' | transloco }}</a>
        {{ 'user.accountDeletion.and' | transloco }}
        <a [href]="termsOfUseUrl" target="_blank" rel="noopener">{{ 'user.accountDeletion.termsOfUse' | transloco }}</a>.
      </p>
    </ng-container>

    <ng-template #successState>
      <h1>{{ 'user.accountDeletion.scheduledTitle' | transloco: { date: scheduledDate } }}</h1>
      <!-- Fase 1: nada foi apagado ainda; o plano "será" cancelado (o servidor pode falhar no Stripe). -->
      <p class="deletion-lead">{{ 'user.accountDeletion.scheduledPlan' | transloco }}</p>
      <p class="deletion-lead">{{ 'user.accountDeletion.scheduledGiveUp' | transloco: { date: scheduledDate } }}</p>
      <div class="deletion-actions">
        <p-button
          severity="danger"
          [raised]="true"
          label="{{ 'user.accountDeletion.goToLogin' | transloco }}"
          (onClick)="goToLogin()">
        </p-button>
      </div>
    </ng-template>

  </div>
</div>
